export default "__VITE_ASSET__BUNYQ$$___"